"use client";

import React, { useCallback } from "react";

import { usePathname } from "next/navigation";

import LayoutNavBarItem from "@/components/Layout/NavBar/Item";

const EARN_NAV_BAR = [
  {
    title: "Explore",
    link: "/explore/",
  },
  {
    title: "Vaults",
    link: "/vaults/",
  },
  {
    title: "Protocols",
    link: "/protocols/",
  },
  {
    title: "$PIGGY",
    link: "/piggy/",
  },
];

export default function LayoutNavBarEarn() {
  const pathname = usePathname();

  const isActive = useCallback((link: string) => pathname === link, [pathname]);

  return (
    <nav className="min-w-screen relative -bottom-[1px] inline-flex h-14 min-h-[56px] w-full items-stretch justify-between space-x-3 md:min-w-0 md:justify-start">
      {EARN_NAV_BAR.map((navItem, index) => (
        <LayoutNavBarItem key={`earn-nav-link-${index}`} isActive={isActive(navItem.link)} link={navItem.link}>
          {navItem.title}
        </LayoutNavBarItem>
      ))}
    </nav>
  );
}
